module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "types": _vm.types,
      "config": _vm.config
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ae1bf5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ckeditor.vue
// module id = 996
// module chunks = 1